import { useState } from "react";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import CreatableSelect from "react-select/creatable";
import { validateArray } from "../../utils/validate";
import { useFormikContext } from "formik";

const InputSubData3Bs = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();
  const { values } = useFormikContext();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });
  const {
    data: document,
    loading: loadDocument,
    call: callDocument,
  } = Request({
    urlApi: field.urlApi,
  });

  function handleForm(item) {
    openDialog(
      <>
        {loadDocument && (
          <FormAddDocument
            data={document}
            item={item}
            reload={call}
            field={field}
            onClose={dialogClose}
            callDocument={callDocument}
            tipoDeCambioProformaAduana={Number(values.tipoDeCambioProformaAduana ?? "0")}
            tipoDeCambioProforma={Number(values.tipoDeCambioProforma ?? "0")}
          />
        )}
        <br />
      </>
    );
  }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }

  return (
    <div className="bg-gray-300/40 p-2 rounded-md">
      <Label htmlFor={field.name} className={`${field.className} my-0`}>
        {field.labelCustom ? field.labelCustom : field.label}
      </Label>
      <div className="bg-gray-100 rounded-lg p-3 pt-2">
        {loadDocument && (
          <FormAddDocument
            data={document}
            reload={call}
            field={field}
            onClose={() => {}}
            callDocument={callDocument}
            tipoDeCambioProformaAduana={Number(values.tipoDeCambioProformaAduana ?? "0")}
            tipoDeCambioProforma={Number(values.tipoDeCambioProforma ?? "0")}
          />
        )}
      </div>
      <br />
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "label",
                label: "Lista de campos",
              },
              {
                name: "description",
                label: "Monto",
              },
              {
                name: "description2",
                label: "Monto Conv.",
              },
              {
                name: "description3",
                label: "Tipo cambio",
              },
              {
                name: "observation",
                label: "Observación",
              },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  {
                    label: "Editar",
                    icon: "fas  fa-edit",
                    action: handleForm,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Añadir",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                ],
              },
            ]}
            data={data}
          />
        </div>
      )}
    </div>
  );
};

const FormAddDocument = (props) => {
  const {
    data,
    item = null,
    reload,
    field,
    onClose,
    callDocument,
    tipoDeCambioProformaAduana = 0,
    tipoDeCambioProforma = 0,
  } = props;

  const initialLabel = item?.label ? item.label : validateArray(data) ? data[0].name : "";
  const isInitialProforma = initialLabel === "RECOJO GUIA" || initialLabel === "PAGO ASP-B";
  const initialTipoCambio = isInitialProforma ? tipoDeCambioProforma : tipoDeCambioProformaAduana;

  const [values, setValues] = useState({
    Label: initialLabel,
    NumberValue: item?.numberValue ? item.numberValue : 0,
    Description: item?.description ? item.description : "",
    Description2: item?.description2 ? item.description2 : "",
    Description3: item?.description3 ? item.description3 : (initialTipoCambio || 0),
    Observation: item?.observation ? item.observation : "",
  });

  async function handleSubmit() {
    if (values.isNew) {
      await handleCreateOption(values);
    }
    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
      values
    )
      .then(() => {
        reload();
        onClose();
        setValues({
          ...values,
          NumberValue: 0,
          Description: "",
          Description2: "",
          Description3: (tipoDeCambioProformaAduana || 0),
          Observation: "",
        });
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  async function handleCreateOption(value) {
    await requestAuth("post", "/Dropdown/Option", {
      Name: value.Label,
      DropdownListLabel: field.urlInitial,
    }).then(() => {
      callDocument();
    });
  }

  function handleChangeInp(e) {
    const { name, value } = e.target;
    setValues((a) => {
      const newValues = { ...a, [name]: value };
      
      if (name === "Description" || name === "Description3") {
        const monto = Number(newValues.Description) || 0;
        const tipoCambio = Number(newValues.Description3) || 0;
        const result = tipoCambio ? monto / tipoCambio : 0;

        newValues.Description2 = parseFloat(result.toFixed(2));
      }
      
      return newValues;
    });
  }

  function handleChange(e) {
    const isProformaLabel = e.value === "RECOJO GUIA" || e.value === "PAGO ASP-B";
    const selectedTipoCambio = isProformaLabel ? tipoDeCambioProforma : tipoDeCambioProformaAduana;

    setValues((a) => {
      const newValues = {
        ...a,
        Label: e.value,
        isNew: e.__isNew__ || false,
        Description3: selectedTipoCambio || 0
      };
      
      const monto = Number(newValues.Description) || 0;
      const tipoCambio = Number(newValues.Description3) || 0;
      const result = tipoCambio ? monto / tipoCambio : 0;
      newValues.Description2 = parseFloat(result.toFixed(2));

      return newValues;
    });
  }

  return (
    <form className="flex flex-col">
      <Label className={`mt-2`}>Lista de campos</Label>
      <CreatableSelect
        isSearchable={true}
        onChange={handleChange}
        styles={{
          placeholder: (base) => ({
            ...base,
            color: "black",
          }),
        }}
        placeholder={"Seleccionar..."}
        isOptionSelected={false}
        value={{
          value: values.Label,
          label: values.Label,
        }}
        options={data.map((option) => ({
          value: option.name,
          label: option.name,
        }))}
      />
      
      <div className="flex flex-col gap-2 mt-2">
        <div className="flex gap-2 items-end">
          <div className="flex flex-col w-1/3">
            <Label className="">Monto</Label>
            <input
              value={values.Description}
              onChange={handleChangeInp}
              className="w-full p-2 rounded-md"
              type="text"
              name="Description"
            />
          </div>
          <div className="flex flex-col w-1/3">
            <Label className="">Monto Conv.</Label>
            <input
              value={values.Description2}
              onChange={handleChangeInp}
              className="w-full p-2 rounded-md"
              type="number"
              name="Description2"
            />
          </div>
          <div className="flex flex-col w-1/3">
            <Label className="">Tipo cambio</Label>
            <input
              value={values.Description3}
              onChange={handleChangeInp}
              className="w-full p-2 rounded-md"
              type="number"
              name="Description3"
            />
          </div>
        </div>
        
        <div className="flex flex-col w-full">
          <Label className="">Observación</Label>
          <input
            value={values.Observation}
            onChange={handleChangeInp}
            className="w-full p-2 rounded-md"
            type="text"
            name="Observation"
          />
        </div>

        <div className="flex justify-end mt-2">
          <Button onClick={(e) => { e.preventDefault(); handleSubmit(); }} className="px-3 py-2">
            Guardar
          </Button>
        </div>
      </div>
    </form>
  );
};

export default InputSubData3Bs;
